angular.module('dpw.components')
    .directive('dpwContentful', ['contentfulService', 'seoService', function (contentfulService, seoService) {
        return {
            restrict: 'A',
            link: function (scope) {
                if (RCDPW.isAdminSite) {
                    return;
                }

                var siteWide = RCDPW.Lang.Contentful.SiteWide;
                seoService.updateKeywords(siteWide.metaKeywords, seoService.from.siteWide);
                seoService.updateDescription(siteWide.metaDescription, seoService.from.siteWide);

                contentfulService.getSiteWide()
                    .then(function (texts) {
                        scope.siteWideTexts = texts;

                        try {
                            seoService.addMetaTags(texts.metaTags.tags, seoService.from.siteWide);
                            seoService.updateKeywords(texts.metaKeywords, seoService.from.siteWide);
                            seoService.updateDescription(texts.metaDescription, seoService.from.siteWide);
                        } catch (e) {
                        }

                    }, function () {
                        try {
                            seoService.addMetaTags(siteWide.metaTags.tags);
                        } catch (e) {
                        }
                    });
            }
        };
    }]);
